import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEXTAREA_CLS, INPUT_ERROR_CLS } from 'helpers/formStyles';

/**
 * Textarea — canonical multi-line input built on helpers/formStyles
 * TEXTAREA_CLS. For label + error scaffolding wrap it in <FormField>.
 */
const Textarea = React.forwardRef(({ error = false, className = '', rows = 3, ...rest }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    className={classNames(TEXTAREA_CLS, error && INPUT_ERROR_CLS, className)}
    {...rest}
  />
));

Textarea.displayName = 'Textarea';

Textarea.propTypes = {
  error: PropTypes.bool,
  className: PropTypes.string,
  rows: PropTypes.number
};

export default Textarea;
